export default __webpack_public_path__ + "static/404_Puppet-8e2a55dfa61147bc144e10e096ebedd3.svg";